import AudioDebugPanel from './AudioDebugPanel';
import { CapabilityDebugPanel } from './CapabilityDebugPanel';
import { FlagDebugPanel } from './FlagDebugPanel';
import { LocationDebugPanel } from './LocationDebugPanel';
import { TextTo911DebugPanel } from './TextTo911DebugPanel';

interface Component {
  onError?: ((error: string) => void) | undefined;
  onClose: () => void;
}

interface DebugPanel {
  id: string;
  label: string;
  component: (props: Component) => JSX.Element;
}

const panels: DebugPanel[] = [
  {
    id: 'audio-debug',
    label: 'Realtime Audio',
    component: ({ onError, onClose }) => (
      <AudioDebugPanel onError={onError} onClose={onClose} />
    ),
  },
  {
    id: 'location-debug',
    label: 'Plot Location',
    component: ({ onClose }) => <LocationDebugPanel onClose={onClose} />,
  },
  {
    id: 'tt911-debug',
    label: 'Text-to-911',
    component: ({ onClose }) => <TextTo911DebugPanel onClose={onClose} />,
  },
  {
    id: 'flag-debug',
    label: 'Feature Flags',
    component: ({ onClose }) => <FlagDebugPanel onClose={onClose} />,
  },
  {
    id: 'capability-debug',
    label: 'Capabilities',
    component: ({ onClose }) => <CapabilityDebugPanel onClose={onClose} />,
  },
];

export default panels;
